"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GroupPhotoHelp;
var React = _interopRequireWildcard(require("react"));
var _internal = require("@aws-amplify/ui-react/internal");
var _uiReact = require("@aws-amplify/ui-react");
var _Iconcheck = _interopRequireDefault(require("./Iconcheck"));
var _excluded = ["overrides"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function GroupPhotoHelp(props) {
  var overrides = props.overrides,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "0",
    direction: "column",
    width: "360px",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "GroupPhotoHelp"), rest), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "40px",
    direction: "column",
    width: "unset",
    height: "600px",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 12px 0px 12px"
  }, (0, _internal.getOverrideProps)(overrides, "GroupPhoto/Help")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "41px",
    direction: "column",
    width: "unset",
    height: "520px",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20786")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "40px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    grow: "1",
    shrink: "1",
    basis: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20988")), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "20px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "30px",
    textAlign: "left",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    width: "unset",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "\xBFQu\xE9 es una fotograf\xEDa de grupo?"
  }, (0, _internal.getOverrideProps)(overrides, "Explenation"))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "10px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    grow: "1",
    shrink: "1",
    basis: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20987")), /*#__PURE__*/React.createElement(_uiReact.Image, _extends({
    width: "unset",
    height: "unset",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    grow: "1",
    shrink: "1",
    basis: "0",
    alignSelf: "stretch",
    position: "relative",
    borderRadius: "15px",
    padding: "0px 0px 0px 0px",
    objectFit: "cover"
  }, (0, _internal.getOverrideProps)(overrides, "Photo"))))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20780")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "9px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "CheckList34712854")), /*#__PURE__*/React.createElement(_Iconcheck.default, _extends({
    width: "20px",
    height: "20px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "icon-check34712896"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "left",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "unset",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    grow: "1",
    shrink: "1",
    basis: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Ayudar\xE1 a llevar un control de asistencia en las reuniones semanales"
  }, (0, _internal.getOverrideProps)(overrides, "Point1")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "9px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "CheckList34712860")), /*#__PURE__*/React.createElement(_Iconcheck.default, _extends({
    width: "20px",
    height: "20px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "icon-check34712899"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "left",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "unset",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    grow: "1",
    shrink: "1",
    basis: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Verifica que aparezcan todas las integrantes del grupo"
  }, (0, _internal.getOverrideProps)(overrides, "Point2")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "9px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "CheckList34712865")), /*#__PURE__*/React.createElement(_Iconcheck.default, _extends({
    width: "20px",
    height: "20px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "icon-check34712902"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "left",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "unset",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    grow: "1",
    shrink: "1",
    basis: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Verifica que sea un lugar con buena iluminaci\xF3n"
  }, (0, _internal.getOverrideProps)(overrides, "Point3")))))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "10px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame button")), /*#__PURE__*/React.createElement(_uiReact.Button, _extends({
    width: "unset",
    height: "unset",
    shrink: "0",
    size: "default",
    isDisabled: false,
    variation: "primary",
    children: "TOMAR FOTO"
  }, (0, _internal.getOverrideProps)(overrides, "Button"))))));
}